<div *ngIf="payPeriods?.length" class="period-selector flex m-x-sm">
  <div class="flex w-100">
    <em class="fa fa-3x fa-caret-left nav-button"
        (click)="navigatePrevious()"
        [class.disabled]="!canNavigateBack"
        [class.text-muted]="!canNavigateBack"
        [tooltip]="canNavigateBack ? ('TOOLTIPS.prev_period' | translate) : ''">
    </em>
    <div class="payperiod-list m-x-1" role="group" #payPeriodList (wheel)="onWheelScroll($event)">
      <button class="btn btn-period" #periodButton *ngFor="let payPeriod of payPeriods"
              (click)="select(payPeriod.id)"
              [class.active]="payPeriod.id === selectedPayPeriod?.id">
        <span>{{ payPeriod.attributes.transid }}</span>
      </button>
    </div>
    <em class="fa fa-3x fa-caret-right nav-button"
        (click)="navigateNext()"
        [class.disabled]="!canNavigateForward"
        [class.text-muted]="!canNavigateForward"
        [tooltip]="canNavigateForward ? ('TOOLTIPS.next_period' | translate) : ''">
    </em>
  </div>
</div>
